import { LegalEntityClassificationApiModel } from "../../../legalEntity/legalEntityClassificationTab/LegalEntityClassificationTab.types";
import { ISystemClassificationTabProps } from "./SystemClassificationTab";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export default function useSystemClassificationTabHooks(props: ISystemClassificationTabProps) {
    const url = `/SystemOverview/${props.systemId}/classifications`;
    let { isLoading, data, refetch } = useDotLegalQuery<LegalEntityClassificationApiModel>(url);
    return {
        isLoading,
        data,
        refetch,
    };
}
